module.exports = {"title":"Europe’s most trusted online aligner solution","image":"/media/about_cover.jpg"}